import { RenderUtils } from '@wix/native-pro-gallery-utils';
class Utils extends RenderUtils {
  /* @ngInject */
  constructor() {
    super();
  }
  pick(obj, keys) {
    const res = {};
    Object.entries(obj || {}).forEach(_ref => {
      let key = _ref[0],
        val = _ref[1];
      if (keys.indexOf(key) >= 0) {
        res[key] = val;
      }
    });
    return res;
  }
  debounce(callback, wait) {
    var _this = this;
    let timeout;
    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        callback.apply(_this, args);
      }, wait);
    };
  }
  get(obj, path, defaultValue) {
    const result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce((res, key) => res !== null && res !== undefined ? res[key] : res, obj);
    return result === undefined || result === obj ? defaultValue : result;
  }
  flipGalleryHorizontalAlign(galleryHorizontalAlign) {
    // Usage in RTL galleries
    return galleryHorizontalAlign === 'flex-start' ? 'flex-end' : galleryHorizontalAlign === 'flex-end' ? 'flex-start' : galleryHorizontalAlign;
  }
}
export const utils = new Utils();
//# sourceMappingURL=utils.js.map